import { collectionEngineV1 } from '../apis.js';
const vouchersAPI = collectionEngineV1('/vouchers');
export const getTypes = () => vouchersAPI('GET', `/types`);
export const createType = (newVoucherType) => vouchersAPI('POST', `/types`, {
    body: newVoucherType,
});
export const patchType = (voucherTypeId, patch) => vouchersAPI('PATCH', `/types/${voucherTypeId}`, {
    body: patch,
});
//# sourceMappingURL=vouchers.js.map